import Button from '@/components/Button/Button';

export const ButtonTest = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4">
        <div className="flex flex-col gap-4 w-30">
          <Button variant="primary">Primary</Button>
          <Button variant="primary" isLoading>
            Primary
          </Button>
          <Button variant="primary" disabled>
            Primary
          </Button>
          <Button variant="outlined">Primary Outlined</Button>
          <Button variant="outlined" disabled>
            Primary Outlined
          </Button>
          <Button variant="secondary">Secondary</Button>
          <Button variant="secondary" disabled>
            Secondary
          </Button>
          <Button variant="outlined">Secondary Outlined</Button>
          <Button variant="outlined" disabled>
            Secondary Outlined
          </Button>
          <Button variant="error">Error</Button>
          <Button variant="error" disabled>
            Error
          </Button>
          <Button variant="error_outlined">Error Outlined</Button>
          <Button variant="error_outlined" disabled>
            Error Outlined
          </Button>
        </div>
        <div className="flex flex-col gap-4 w-35">
          <Button sizeType="m" variant="primary">
            Primary
          </Button>
          <Button sizeType="m" variant="primary" isLoading>
            Primary
          </Button>
          <Button sizeType="m" variant="primary" disabled>
            Primary
          </Button>
          <Button sizeType="m" variant="outlined">
            Primary Outlined
          </Button>
          <Button sizeType="m" variant="outlined" disabled>
            Primary Outlined
          </Button>
          <Button sizeType="m" variant="secondary">
            Secondary
          </Button>
          <Button sizeType="m" variant="secondary" disabled>
            Secondary
          </Button>
          <Button sizeType="m" variant="outlined">
            Secondary Outlined
          </Button>
          <Button sizeType="m" variant="outlined" disabled>
            Secondary Outlined
          </Button>
          <Button sizeType="m" variant="error">
            Error
          </Button>
          <Button sizeType="m" variant="error" disabled>
            Error
          </Button>
          <Button sizeType="m" variant="error_outlined">
            Error Outlined
          </Button>
          <Button sizeType="m" variant="error_outlined" disabled>
            Error Outlined
          </Button>
        </div>
        <div className="flex flex-col gap-4 w-40">
          <Button sizeType="l" variant="primary">
            Primary
          </Button>
          <Button sizeType="l" variant="primary" isLoading>
            Primary
          </Button>
          <Button sizeType="l" variant="primary" disabled>
            Primary
          </Button>
          <Button sizeType="l" variant="outlined">
            Primary Outlined
          </Button>
          <Button sizeType="l" variant="outlined" disabled>
            Primary Outlined
          </Button>
          <Button sizeType="l" variant="secondary">
            Secondary
          </Button>
          <Button sizeType="l" variant="secondary" disabled>
            Secondary
          </Button>
          <Button sizeType="l" variant="outlined">
            Secondary Outlined
          </Button>
          <Button sizeType="l" variant="outlined" disabled>
            Secondary Outlined
          </Button>
          <Button sizeType="l" variant="error">
            Error
          </Button>
          <Button sizeType="l" variant="error" disabled>
            Error
          </Button>
          <Button sizeType="l" variant="error_outlined">
            Error Outlined
          </Button>
          <Button sizeType="l" variant="error_outlined" disabled>
            Error Outlined
          </Button>
        </div>
        <div className="flex flex-col gap-4 w-50">
          <Button sizeType="xl" variant="primary">
            Primary
          </Button>
          <Button sizeType="xl" variant="primary" isLoading>
            Primary
          </Button>
          <Button sizeType="xl" variant="primary" disabled>
            Primary
          </Button>
          <Button sizeType="xl" variant="outlined">
            Primary Outlined
          </Button>
          <Button sizeType="xl" variant="outlined" disabled>
            Primary Outlined
          </Button>
          <Button sizeType="xl" variant="secondary">
            Secondary
          </Button>
          <Button sizeType="xl" variant="secondary" disabled>
            Secondary
          </Button>
          <Button sizeType="xl" variant="outlined">
            Secondary Outlined
          </Button>
          <Button sizeType="xl" variant="outlined" disabled>
            Secondary Outlined
          </Button>
          <Button sizeType="xl" variant="error">
            Error
          </Button>
          <Button sizeType="xl" variant="error" disabled>
            Error
          </Button>
          <Button sizeType="xl" variant="error_outlined">
            Error Outlined
          </Button>
          <Button sizeType="xl" variant="error_outlined" disabled>
            Error Outlined
          </Button>
        </div>
      </div>
    </div>
  );
};
